import { useRepositoryMutation } from '@mews-commander/data-access';
import {
    CommanderFormProps,
    SchemaFormFields,
    useDialogForm,
    useHandledDialogFormControls,
} from '@mews-commander/form';
import { createZodFormResolver, lt, showSuccessAlert } from '@mews/framework';
import { convertUseForFormValueToApplicableBillType } from '../../../utils';
import {
    creditNoteCounterDefaultValues,
    getCreditNoteCounterFormDefinition,
    creditNoteCounterValidationSchema,
    CreditNoteFormValues,
} from './formMapping';

const CreateCreditNoteForm = (props: CommanderFormProps) => {
    const { mutateAsync } = useRepositoryMutation('creditNoteBillCounters', 'add', {
        invalidateQueries: { counters: ['getAll'] },
    });

    const onSubmit = async (values: CreditNoteFormValues) => {
        await mutateAsync({
            value: values.startValue,
            displayCid: values.displayCID,
            applicableBillType: convertUseForFormValueToApplicableBillType(values.useFor),
            title: values.title,
            isDefault: values.isDefault,
            numberOfDigits: values.numberOfDigits,
            prefix: values.prefix,
            name: values.name,
            billTypeCode: values.billTypeCode,
        });

        showSuccessAlert({
            title: lt('CreateCounterSuccessMessage', { name: values.name }),
        });
    };

    const { renderFormContent } = useHandledDialogFormControls<CreditNoteFormValues>({
        ...props,
        resolver: createZodFormResolver(creditNoteCounterValidationSchema),
        onSubmit,
        defaultValues: creditNoteCounterDefaultValues,
    });

    return renderFormContent(
        <SchemaFormFields
            formDefinition={getCreditNoteCounterFormDefinition(false, creditNoteCounterDefaultValues)}
            schema={creditNoteCounterValidationSchema}
        />
    );
};

export const useCreateCreditNoteCounterDialog = () =>
    useDialogForm({
        id: 'credit-note-create-dialog',
        title: lt('CreditNoteCounterCreateTitle'),
        saveLabel: lt('Create'),
        renderForm: (props) => <CreateCreditNoteForm {...props} />,
    });
